import React from "react";
import { Trans, withTranslation } from "react-i18next";
import { Multiselect } from "multiselect-react-dropdown";
import { Translation } from "react-i18next";
import AddIcon from "../UIComponents/AddIcon";
import { connect } from "react-redux";
import { withRouter } from "react-router-dom";
import {
  postEquipmentDetails,
  getShipManagementList,
} from "../Actions/ShipManagementAPI";
import { confirmAlert } from "react-confirm-alert";
import {
  postFirePlanAttachment,
  postShipContractAttachment,
  deleteAttachmentInBucket
} from "../Actions/CommonAPI";
import {
  getFlagList,
  getClientUsersList,
  getClassList,
  getClientNameList,
  getTypeofShipList,
  getApproverNameList,
  getCoordinatorNameList,
} from "../Actions/helpersAPI";
import axios from "axios";
import API from "../helpers/api";
import DatePicker from "react-datepicker";
import Moment from "moment";
import swal from "sweetalert";
import { toast } from "react-toastify";
import $ from "jquery";
import Autocomplete from "@mui/material/Autocomplete";
import TextField from "@mui/material/TextField";
import { WidgetsTwoTone } from "@material-ui/icons";

var fileDatas = [];
let searchData = {
  ShipName: "",
  ImoNo: "",
  Flag: "",
  Class: "",
  Grt: "",
  status: "active",
  DeadWeight: "",
  PageNumber: 1,
  PageSize: 20,
};
let currentUser = JSON.parse(localStorage.getItem("currentUser"));
class ShipManagementNewItem extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      shipInfo: {
        shipName: "",
        flag: "",
        class: "",
        grt: "",
        imoNo: "",
        status: "",
        firePlanName: "",
        nameOfContract: "",
        contractGUID: "",
        firePlanGUID: "",
        deadWeight: "",
        dateOfBuild: "",
        enrollmentDate: "",
        approverId: 0,
        grantAdmins: [],
        typeOfShip: "",
        shipEmail: "",
        invoiceForwardingEmail: "",
        vesselGroupEmail: "",
        phone1: "",
        phone2: "",
        companyName: "",
        contractName: "",
        contractStatus: "pending",
        createdBy: currentUser.name,
        shipUsers: [],
        contractType: "",
        planType: "",
        isContract: false
      },
      selectClass: [],
      maxClassselect: 2,
      FileUploadstatus: false,
      ContractUploadstatus: false,
      file: "",
      fileName: "",
      attachment: "",
      attachmentName: "",
      fleetmanager: [],
      superintendent: [],
      technicalexecutive: [],
      grantAdmins: [],
      Pending: true,
      Active: false,
      Terminated: false,
      Equipmentlist: [],
      DatePickerIsOpen: "",
      EnrollmentDatePickerIsOpen: false,
    };
    this.handleInputChange = this.handleInputChange.bind(this);
    this.handleCompanyInputChange = this.handleCompanyInputChange.bind(this);
    this.handleContractInputChange = this.handleContractInputChange.bind(this);
    this.handleDateofBuild = this.handleDateofBuild.bind(this);
    this.openDatePicker = this.openDatePicker.bind(this);
    this.openEnrollmentDatePicker = this.openEnrollmentDatePicker.bind(this);
    this.handleEnrollmentDate = this.handleEnrollmentDate.bind(this);
    this.handleBlur = this.handleBlur.bind(this);
    this.AddShipDraft = this.AddShipDraft.bind(this);
    this.AddShipActive = this.AddShipActive.bind(this);
    this.AssignUsers = this.AssignUsers.bind(this);
    this.ClearInput = this.ClearInput.bind(this);
    this.onSelectChange = this.onSelectChange.bind(this);
    this.onRemoveChange = this.onRemoveChange.bind(this);
  }

  componentDidMount() {
    const { dispatch } = this.props;
    dispatch({ type: "SubBannerTitle", data: "Ship Management" })
    dispatch(getFlagList());
    dispatch(getClassList("class"));
    dispatch(getClientNameList());
    dispatch(getTypeofShipList("typeofship"));
    dispatch(getApproverNameList());
    dispatch(getCoordinatorNameList());
  }

  static getDerivedStateFromProps(nextProps, prevState) {
    const {
      EquipmentArray,
      FirePlanAttachment,
      dispatch,
      ShipContractAttachment,
    } = nextProps;
    if (FirePlanAttachment) {
      prevState.shipInfo.firePlanName = FirePlanAttachment.FileName;
      prevState.shipInfo.firePlanGUID = FirePlanAttachment.Guid;
    }
    if (ShipContractAttachment) {
      prevState.shipInfo.nameOfContract = ShipContractAttachment.FileName;
      prevState.shipInfo.contractGUID = ShipContractAttachment.Guid;
    }
    if (prevState.file !== "") {
      dispatch(postFirePlanAttachment(prevState.file));
      prevState.file = "";
    }
    if (prevState.attachment !== "") {
      dispatch(postShipContractAttachment(prevState.attachment));
      prevState.attachment = "";
    }
    if (EquipmentArray) {
      prevState.Equipmentlist = EquipmentArray;
    }
  }

  CancelAddship() {
    this.props.dispatch({ type: "ShowSidePan", data: false });
    this.props.history.push("/Home/ShipManagement");
  }
  onSelectChange(item) {
    if (item.length <= 2) {
      this.state.selectClass = item;
      this.setState({});
    }
  }

  onRemoveChange(item) {
    this.state.selectClass = item;
    this.setState({});
  }

  AddShipDraft() {
    const { t } = this.props;
    if (
      this.state.shipInfo.shipEmail === "" ||
      this.state.shipInfo.enrollmentDate === "" ||
      this.state.shipInfo.dateOfBuild === "" ||
      this.state.shipInfo.shipName === "" ||
      this.state.shipInfo.companyName === "" ||
      this.state.shipInfo.imoNo === "" ||
      this.state.shipInfo.flag === "" ||
      this.state.selectClass.length === 0
    ) {
      this.state.shipInfo.shipEmail === ""
        ? $("#shipemail").addClass("Error-border")
        : $("#shipemail").removeClass("Error-border");
      this.state.shipInfo.shipName === ""
        ? $("#shipname").addClass("Error-border")
        : $("#shipname").removeClass("Error-border");
      this.state.shipInfo.enrollmentDate === ""
        ? $("#enrollmentdate").addClass("Error-border")
        : $("#enrollmentdate").removeClass("Error-border");
      this.state.shipInfo.dateOfBuild === ""
        ? $("#dateofbuild").addClass("Error-border")
        : $("#dateofbuild").removeClass("Error-border");
      this.state.shipInfo.companyName === ""
        ? $("#companyname").addClass("Error-border")
        : $("#companyname").removeClass("Error-border");
      this.state.shipInfo.imoNo === ""
        ? $("#imono").addClass("Error-border")
        : $("#imono").removeClass("Error-border");
      this.state.shipInfo.flag === ""
        ? $("#flagname").addClass("Error-border")
        : $("#flagname").removeClass("Error-border");
      this.state.selectClass.length === 0
        ? $("#selectclass").addClass("Error-border")
        : $("#selectclass").removeClass("Error-border");
      return;
    } else {
      $("#shipname").removeClass("Error-border");
      $("#enrollmentdate").removeClass("Error-border");
      $("#dateofbuild").removeClass("Error-border");
      $("#companyname").removeClass("Error-border");
      $("#shipemail").removeClass("Error-border");
      $("#imono").removeClass("Error-border");
      $("#flagname").removeClass("Error-border");
      $("#selectclass").removeClass("Error-border");
    }
    confirmAlert({
      message: `${t("ShipManagementContent.DraftMsg")}`,
      buttons: [
        {
          label: `${t("confirmAlertMessage.Yes")}`,
          onClick: () => {
            const { dispatch, EquipmentArray, history } = this.props;
            console.log("shipDetail", this.state.shipInfo);
            this.state.shipInfo.status = "draft";
            this.state.shipInfo.class = this.state.selectClass ? this.state.selectClass.toString() : "";
            this.state.shipInfo.approverId = this.state.shipInfo.approverId ? this.state.shipInfo.approverId : 0;
            let userRoles = [
              { userName: this.state.fleetmanager ? this.state.fleetmanager : null, role: "fleetmanager" },
              { userName: this.state.superintendent ? this.state.superintendent : null, role: "superintendent" },
              { userName: this.state.technicalexecutive ? this.state.technicalexecutive : null, role: "technicalexecutive" }
            ];
            let grandAdmins = this.state.grantAdmins.map((data) => ({
              id: data.id,
              name: data.name
            }))
            this.state.shipInfo.grantAdmins = grandAdmins;
            let userarray = [];
            this.state.fleetmanager.map((data, index) => {
              let userdata = { "userName": data, "role": 'fleetmanager' };
              userarray.push(userdata);
            })
            this.state.technicalexecutive.map((data, index) => {
              let userdata = { "userName": data, "role": 'technicalexecutive' };
              userarray.push(userdata);
            })
            this.state.superintendent.map((data, index) => {
              let userdata = { "userName": data, "role": 'superintendent' };
              userarray.push(userdata);
            })
            this.state.shipInfo.shipUsers = userarray;
            this.setState({});
            let url2 = `${API.userExist}?Mail=${this.state.shipInfo.shipEmail}`;
            axios
              .get(url2, {
                headers: {
                  key: currentUser.accessToken,
                },
              })
              .then((response) => {
                if (response.data === true) {
                  let url = `${API.getShipDetail}`;
                  axios
                    .post(url, this.state.shipInfo, {
                      headers: {
                        key: currentUser.accessToken,
                      },
                    })
                    .then((response) => {
                      // if (response.data === "Staff Add Failed") {
                      //     swal('Error!', 'Staff Add Failed', 'warning');
                      // } else {
                      if (EquipmentArray && EquipmentArray !== "") {
                        let equip = EquipmentArray.map((f) => {
                          let equipmentinfo = {
                            shipId: response.data,
                            equipmentName: f.equipmentName,
                            equipmentType: f.equipmentType,
                            equipmentContractTypeId: f.equipmentContractTypeId ? f.equipmentContractTypeId : 0,
                            recentlyUpdated: false,
                            lifeboatRelease: f.lifeboatRelease
                              ? f.lifeboatRelease
                              : "",
                            davitwinchMakeId: f.davitwinchMakeId
                              ? f.davitwinchMakeId
                              : 0,
                            lifeboatMakeId: f.lifeboatMakeId
                              ? f.lifeboatMakeId
                              : 0,
                            lifeboatModelId: f.lifeboatModelId
                              ? f.lifeboatModelId
                              : 0,
                            rescueboatMakeId: f.rescueboatMake
                              ? f.rescueboatMakeId
                              : 0,
                            rescueboatModelId: f.rescueboatModel
                              ? f.rescueboatModelId
                              : 0,
                            rescueboatdavitwinchMakeId:
                              f.rescueboatdavitwinchMakeId
                                ? f.rescueboatdavitwinchMakeId
                                : 0,
                            rescueboatRelease: f.rescueboatRelease
                              ? f.rescueboatRelease
                              : "",
                            capacity: f.capacity,
                            category: f.category,
                            dateOfBuild: f.dateOfBuild,
                            makeId: f.makeId ? f.makeId : 0,
                            modelId: f.modelId ? f.modelId : 0,
                            quantity: f.quantity,
                            unit: f.unit,
                            serviceDetails: f.serviceDetails,
                            applicableServices: f.applicableServices,
                            createdBy: currentUser.name,
                          };
                          return equipmentinfo;
                        });

                        dispatch(postEquipmentDetails(equip, searchData));
                      }

                      if (fileDatas.length > 0) {
                        this.props.dispatch(deleteAttachmentInBucket(fileDatas));
                        fileDatas = [];
                      }
                      this.CancelAddship();
                      toast.success(`${t("CommonText.CommonAdd")}`, {
                        position: "top-right",
                        autoClose: 5000,
                        hideProgressBar: true,
                        closeOnClick: true,
                        pauseOnHover: true,
                        draggable: true,
                        progress: undefined,
                      });
                      dispatch(getShipManagementList(searchData));
                      // }
                      dispatch({
                        type: "PostShipDetailSuccess",
                        data: response.data,
                      });
                    })
                    .catch((error) => {
                      dispatch({
                        type: "PostShipDetailFailure",
                        data: "error",
                      });
                    });
                } else if (response.data === false) {
                  swal(
                    "Error!",
                    `${t("ShipManagementContent.UserErrorMsg")}`,
                    "warning"
                  );
                  this.state.shipInfo.shipEmail = "";
                  this.setState({});
                }
                dispatch({
                  type: "getUserExistListSuccess",
                  data: response.data,
                });
              })
              .catch((error) => {
                dispatch({
                  type: "getUserExistListFailure",
                  data: "error",
                });
              });
          },
        },

        {
          label: `${t("confirmAlertMessage.No")}`,
          onClick: () => {
            $(".checkboxesship").prop("checked", false);
          },
        },
      ],
    });
  }
  AddShipActive() {
    const { t } = this.props;
    if (
      this.state.shipInfo.shipEmail === "" ||
      this.state.shipInfo.enrollmentDate === "" ||
      this.state.shipInfo.dateOfBuild === "" ||
      this.state.shipInfo.shipName === "" ||
      this.state.shipInfo.companyName === "" ||
      this.state.shipInfo.imoNo === "" ||
      this.state.shipInfo.flag === "" ||
      this.state.selectClass.length === 0
      // ||
      // this.state.shipInfo.contractType === "" ||
      // this.state.shipInfo.planType === ""
    ) {
      this.state.shipInfo.shipEmail === ""
        ? $("#shipemail").addClass("Error-border")
        : $("#shipemail").removeClass("Error-border");
      this.state.shipInfo.shipName === ""
        ? $("#shipname").addClass("Error-border")
        : $("#shipname").removeClass("Error-border");
      this.state.shipInfo.enrollmentDate === ""
        ? $("#enrollmentdate").addClass("Error-border")
        : $("#enrollmentdate").removeClass("Error-border");
      this.state.shipInfo.dateOfBuild === ""
        ? $("#dateofbuild").addClass("Error-border")
        : $("#dateofbuild").removeClass("Error-border");
      this.state.shipInfo.companyName === ""
        ? $("#companyname").addClass("Error-border")
        : $("#companyname").removeClass("Error-border");
      !this.state.shipInfo.contractType
        ? $("#contractType").addClass("Error-border")
        : $("#contractType").removeClass("Error-border");
      !this.state.shipInfo.planType
        ? $("#planType").addClass("Error-border")
        : $("#planType").removeClass("Error-border");
      !this.state.shipInfo.imoNo
        ? $("#imono").addClass("Error-border")
        : $("#imono").removeClass("Error-border");
      this.state.shipInfo.flag === ""
        ? $("#flagname").addClass("Error-border")
        : $("#flagname").removeClass("Error-border");
      this.state.selectClass.length === 0
        ? $("#selectclass").addClass("Error-border")
        : $("#selectclass").removeClass("Error-border");
      return;
    } else {
      $("#shipname").removeClass("Error-border");
      $("#enrollmentdate").removeClass("Error-border");
      $("#dateofbuild").removeClass("Error-border");
      $("#companyname").removeClass("Error-border");
      $("#shipemail").removeClass("Error-border");
      $("#contractType").removeClass("Error-border");
      $("#planType").removeClass("Error-border");
      $("#imono").removeClass("Error-border");
      $("#flagname").removeClass("Error-border");
      $("#selectclass").removeClass("Error-border");
    }
    confirmAlert({
      message: `${t("ShipManagementContent.SubmitMsg")}`,
      buttons: [
        {
          label: `${t("confirmAlertMessage.Yes")}`,
          onClick: () => {
            const { dispatch, EquipmentArray, history } = this.props;
            console.log("shipDetail", this.state.shipInfo);
            this.state.shipInfo.status = "active";
            this.state.shipInfo.class = this.state.selectClass ? this.state.selectClass.toString() : "";
            this.state.shipInfo.approverId = this.state.shipInfo.approverId ? this.state.shipInfo.approverId : 0;
            let userRoles = [
              { userName: this.state.fleetmanager ? this.state.fleetmanager : null, role: "fleetmanager" },
              { userName: this.state.superintendent ? this.state.superintendent : null, role: "superintendent" },
              { userName: this.state.technicalexecutive ? this.state.technicalexecutive : null, role: "technicalexecutive" }
            ];
            let grandAdmins = this.state.grantAdmins.map((data) => ({
              id: data.id,
              name: data.name
            }))
            this.state.shipInfo.grantAdmins = grandAdmins;
            let userarray = [];
            this.state.fleetmanager.map((data, index) => {
              let userdata = { "userName": data, "role": 'fleetmanager' };
              userarray.push(userdata);
            })
            this.state.technicalexecutive.map((data, index) => {
              let userdata = { "userName": data, "role": 'technicalexecutive' };
              userarray.push(userdata);
            })
            this.state.superintendent.map((data, index) => {
              let userdata = { "userName": data, "role": 'superintendent' };
              userarray.push(userdata);
            })
            this.state.shipInfo.shipUsers = userarray;
            this.setState({});
            let url2 = `${API.userExist}?Mail=${this.state.shipInfo.shipEmail}`;
            axios
              .get(url2, {
                headers: {
                  key: currentUser.accessToken,
                },
              })
              .then((response) => {
                if (response.data === true) {
                  let url = `${API.getShipDetail}`;
                  axios
                    .post(url, this.state.shipInfo, {
                      headers: {
                        key: currentUser.accessToken,
                      },
                    })
                    .then((response) => {
                      // if (response.data === "Staff Add Failed") {
                      //     swal('Error!', 'Staff Add Failed', 'warning');
                      // } else {
                      if (EquipmentArray && EquipmentArray !== "") {
                        let equip = EquipmentArray.map((f) => {
                          let equipmentinfo = {
                            shipId: response.data,
                            equipmentName: f.equipmentName,
                            equipmentContractTypeId: f.equipmentContractTypeId ? f.equipmentContractTypeId : 0,
                            recentlyUpdated: false,
                            equipmentType: f.equipmentType,
                            lifeboatRelease: f.lifeboatRelease
                              ? f.lifeboatRelease
                              : "",
                            davitwinchMakeId: f.davitwinchMakeId
                              ? f.davitwinchMakeId
                              : 0,
                            lifeboatMakeId: f.lifeboatMakeId
                              ? f.lifeboatMakeId
                              : 0,
                            lifeboatModelId: f.lifeboatModelId
                              ? f.lifeboatModelId
                              : 0,
                            rescueboatMakeId: f.rescueboatMake
                              ? f.rescueboatMakeId
                              : 0,
                            rescueboatModelId: f.rescueboatModel
                              ? f.rescueboatModelId
                              : 0,
                            rescueboatdavitwinchMakeId:
                              f.rescueboatdavitwinchMakeId
                                ? f.rescueboatdavitwinchMakeId
                                : 0,
                            rescueboatRelease: f.rescueboatRelease
                              ? f.rescueboatRelease
                              : "",
                            capacity: f.capacity,
                            category: f.category,
                            dateOfBuild: f.dateOfBuild,
                            makeId: f.makeId ? f.makeId : 0,
                            modelId: f.modelId ? f.modelId : 0,
                            quantity: f.quantity,
                            unit: f.unit,
                            serviceDetails: f.serviceDetails,
                            createdBy: currentUser.name,
                            applicableServices: f.applicableServices
                          };
                          return equipmentinfo;
                        });

                        dispatch(postEquipmentDetails(equip, searchData));
                      }

                      if (fileDatas.length > 0) {
                        this.props.dispatch(deleteAttachmentInBucket(fileDatas));
                        fileDatas = [];
                      }
                      this.CancelAddship();
                      toast.success(`${t("CommonText.CommonAdd")}`, {
                        position: "top-right",
                        autoClose: 5000,
                        hideProgressBar: true,
                        closeOnClick: true,
                        pauseOnHover: true,
                        draggable: true,
                        progress: undefined,
                      });
                      dispatch(getShipManagementList(searchData));
                      // }
                      dispatch({
                        type: "PostShipDetailSuccess",
                        data: response.data,
                      });
                    })
                    .catch((error) => {
                      dispatch({
                        type: "PostShipDetailFailure",
                        data: "error",
                      });
                    });
                } else if (response.data === false) {
                  swal(
                    "Error!",
                    `${t("ShipManagementContent.UserErrorMsg")}`,
                    "warning"
                  );
                  this.state.shipInfo.shipEmail = "";
                  this.setState({});
                }
                dispatch({
                  type: "getUserExistListSuccess",
                  data: response.data,
                });
              })
              .catch((error) => {
                dispatch({
                  type: "getUserExistListFailure",
                  data: "error",
                });
              });
          },
        },

        {
          label: `${t("confirmAlertMessage.No")}`,
          onClick: () => {
            $(".checkboxesship").prop("checked", false);
          },
        },
      ],
    });
  }
  AssignUsers() {
    const { dispatch, EquipmentArray, t } = this.props;
    if (
      this.state.shipInfo.shipEmail === "" ||
      this.state.shipInfo.enrollmentDate === "" ||
      this.state.shipInfo.dateOfBuild === "" ||
      this.state.shipInfo.shipName === "" ||
      this.state.shipInfo.companyName === "" ||
      this.state.shipInfo.imoNo === "" ||
      this.state.shipInfo.flag === "" ||
      this.state.selectClass.length === 0

    ) {
      this.state.shipInfo.shipEmail === ""
        ? $("#shipemail").addClass("Error-border")
        : $("#shipemail").removeClass("Error-border");
      this.state.shipInfo.shipName === ""
        ? $("#shipname").addClass("Error-border")
        : $("#shipname").removeClass("Error-border");
      this.state.shipInfo.enrollmentDate === ""
        ? $("#enrollmentdate").addClass("Error-border")
        : $("#enrollmentdate").removeClass("Error-border");
      this.state.shipInfo.dateOfBuild === ""
        ? $("#dateofbuild").addClass("Error-border")
        : $("#dateofbuild").removeClass("Error-border");
      this.state.shipInfo.companyName === ""
        ? $("#companyname").addClass("Error-border")
        : $("#companyname").removeClass("Error-border");
      this.state.shipInfo.imoNo === ""
        ? $("#imono").addClass("Error-border")
        : $("#imono").removeClass("Error-border");
      this.state.shipInfo.flag === ""
        ? $("#flagname").addClass("Error-border")
        : $("#flagname").removeClass("Error-border");
      this.state.selectClass.length === 0
        ? $("#selectclass").addClass("Error-border")
        : $("#selectclass").removeClass("Error-border");
      return;
    } else {
      $("#shipname").removeClass("Error-border");
      $("#enrollmentdate").removeClass("Error-border");
      $("#dateofbuild").removeClass("Error-border");
      $("#companyname").removeClass("Error-border");
      $("#shipemail").removeClass("Error-border");
      $("#imono").removeClass("Error-border");
      $("#flagname").removeClass("Error-border");
      $("#selectclass").removeClass("Error-border");
    }
    if (
      this.state.grantAdmins?.length === 0 ||
      this.state.shipInfo.approverId === 0
      // this.state.shipInfo.grantAdminId === 0 ||
      // this.state.shipInfo.approverId === 0
    ) {
      swal(
        "Error!",
        `${t("ShipManagementContent.CoordinatorErrorMsg")}`,
        "warning"
      );
      return;
    } else {
      confirmAlert({
        message: `${t("ShipManagementContent.CoordinatorMsg")}`,
        buttons: [
          {
            label: `${t("confirmAlertMessage.Yes")}`,
            onClick: () => {
              console.log("shipDetail", this.state.shipInfo);
              let userarray = [];
              this.state.fleetmanager.map((data, index) => {
                let userdata = { "userName": data, "role": 'fleetmanager' };
                userarray.push(userdata);
              })
              this.state.technicalexecutive.map((data, index) => {
                let userdata = { "userName": data, "role": 'technicalexecutive' };
                userarray.push(userdata);
              })
              this.state.superintendent.map((data, index) => {
                let userdata = { "userName": data, "role": 'superintendent' };
                userarray.push(userdata);
              })
              this.state.shipInfo.shipUsers = userarray;
              let grandAdmins = this.state.grantAdmins.map((data) => ({
                id: data.id,
                name: data.name
              }))
              this.state.shipInfo.grantAdmins = grandAdmins;
              this.state.shipInfo.class = this.state.selectClass ? this.state.selectClass.toString() : "";
              this.state.shipInfo.approverId = this.state.shipInfo.approverId ? this.state.shipInfo.approverId : 0;
              this.state.shipInfo.status = "pending";
              this.setState({});
              let url2 = `${API.userExist}?Mail=${this.state.shipInfo.shipEmail}`;
              axios
                .get(url2, {
                  headers: {
                    key: currentUser.accessToken,
                  },
                })
                .then((response) => {
                  if (response.data === true) {
                    let url = `${API.getShipDetail}`;
                    axios
                      .post(url, this.state.shipInfo, {
                        headers: {
                          key: currentUser.accessToken,
                        },
                      })
                      .then((response) => {
                        // if (response.data === "Staff Add Failed") {
                        //     swal('Error!', 'Staff Add Failed', 'warning');
                        // } else {
                        if (EquipmentArray && EquipmentArray !== "") {
                          let equip = EquipmentArray.map((f) => {
                            let equipmentinfo = {
                              shipId: response.data,
                              equipmentName: f.equipmentName,
                              equipmentContractTypeId: f.equipmentContractTypeId ? f.equipmentContractTypeId : 0,
                              recentlyUpdated: false,
                              equipmentType: f.equipmentType,
                              lifeboatRelease: f.lifeboatRelease
                                ? f.lifeboatRelease
                                : "",
                              davitwinchMakeId: f.davitwinchMakeId
                                ? f.davitwinchMakeId
                                : 0,
                              lifeboatMakeId: f.lifeboatMakeId
                                ? f.lifeboatMakeId
                                : 0,
                              lifeboatModelId: f.lifeboatModelId
                                ? f.lifeboatModelId
                                : 0,
                              rescueboatMakeId: f.rescueboatMake
                                ? f.rescueboatMakeId
                                : 0,
                              rescueboatModelId: f.rescueboatModel
                                ? f.rescueboatModelId
                                : 0,
                              rescueboatdavitwinchMakeId:
                                f.rescueboatdavitwinchMakeId
                                  ? f.rescueboatdavitwinchMakeId
                                  : 0,
                              rescueboatRelease: f.rescueboatRelease
                                ? f.rescueboatRelease
                                : "",
                              capacity: f.capacity,
                              category: f.category,
                              dateOfBuild: f.dateOfBuild,
                              makeId: f.makeId ? f.makeId : 0,
                              modelId: f.modelId ? f.modelId : 0,
                              quantity: f.quantity,
                              unit: f.unit,
                              serviceDetails: f.serviceDetails,
                              applicableServices: f.applicableServices,
                              createdBy: currentUser.name,
                              isContractApplicable: f.isContractApplicable
                            };
                            return equipmentinfo;
                          });

                          dispatch(postEquipmentDetails(equip, searchData));
                        }

                        if (fileDatas.length > 0) {
                          this.props.dispatch(deleteAttachmentInBucket(fileDatas));
                          fileDatas = [];
                        }
                        this.CancelAddship();
                        toast.success(`${t("CommonText.CommonAdd")}`, {
                          position: "top-right",
                          autoClose: 5000,
                          hideProgressBar: true,
                          closeOnClick: true,
                          pauseOnHover: true,
                          draggable: true,
                          progress: undefined,
                        });
                        dispatch(getShipManagementList(searchData));
                        // }
                        dispatch({
                          type: "PostShipDetailSuccess",
                          data: response.data,
                        });
                      })
                      .catch((error) => {
                        dispatch({
                          type: "PostShipDetailFailure",
                          data: "error",
                        });
                      });
                  } else if (response.data === false) {
                    swal(
                      "Error!",
                      `${t("ShipManagementContent.UserErrorMsg")}`,
                      "warning"
                    );
                    this.state.shipInfo.shipEmail = "";
                    this.setState({});
                  }
                  dispatch({
                    type: "getUserExistListSuccess",
                    data: response.data,
                  });
                })
                .catch((error) => {
                  dispatch({
                    type: "getUserExistListFailure",
                    data: "error",
                  });
                });
            },
          },
          {
            label: `${t("confirmAlertMessage.No")}`,
            onClick: () => { },
          },
        ],
      });
    }
  }
  handleDateofBuild(date) {
    this.state.shipInfo.dateOfBuild = Moment(new Date(Date.parse(date))).format(
      "YYYY-MM-DD"
    );
    this.setState({
      DatePickerIsOpen: false,
    });
  }
  handleEnrollmentDate(date) {
    this.state.shipInfo.enrollmentDate = Moment(
      new Date(Date.parse(date))
    ).format("YYYY-MM-DD");
    this.setState({
      EnrollmentDatePickerIsOpen: false,
    });
  }

  openDatePicker() {
    this.setState({
      DatePickerIsOpen: !this.state.DatePickerIsOpen,
    });
  }
  openEnrollmentDatePicker() {
    this.setState({
      EnrollmentDatePickerIsOpen: !this.state.EnrollmentDatePickerIsOpen,
    });
  }
  handleBlur() {
    this.setState({
      DatePickerIsOpen: false,
      EnrollmentDatePickerIsOpen: false,
    });
  }

  CancelAddship = () => {
    this.props.dispatch({ type: "ShowSidePan", data: false });
    this.props.history.push("/Home/ShipManagement");
  };

  handleInputChange(e) {
    const { t } = this.props;
    let nodeName = e.target.name;
    if (nodeName === "fileName") {
      let filename = e.target.files[0].name;
      var upload = filename.split(".").pop();
      if (upload.toLowerCase() === "pdf") {
        $("#FileErrMsg").text("");
        let regex = /^[0-9a-zA-Z\s\(\)\.\_\&\$\#\-\']+$/g;
        if (regex.test(filename)) {
          this.setState({
            FileUploadstatus: true,
            file: e.target.files[0],
            fileName: e.target.files[0].name,
          });
        } else {
          // swal(
          //   "Error!",
          //   "Please upload the file without special characters.",
          //   "warning"
          // );
          swal({
            title: t('SwalError.ErrorTitle'),
            text: t('SwalError.UploadFile'),
            icon: 'warning',
            buttons: {
              confirm: {
                text: t('confirmAlertMessage.Ok')
              }
            }
          });
          return;
        }
      } else {
        $("#FileErrMsg").text(`${t("ErrorMessage.Onlyptf")}`);
      }
    } else if (nodeName === "phone1") {
      const phone1 = e.target.validity.valid
        ? e.target.value
        : this.state.shipInfo.phone1;
      this.state.shipInfo[nodeName] = phone1;
      this.setState({});
    } else if (nodeName === "phone2") {
      const phone2 = e.target.validity.valid
        ? e.target.value
        : this.state.shipInfo.phone2;
      this.state.shipInfo[nodeName] = phone2;
      this.setState({});
    } else {
      this.state.shipInfo[nodeName] = nodeName == "contractType" || nodeName == "planType" ? parseInt(e.target.value) : e.target.value;
      this.setState({});
    }
  }
  handleAttachmentInputChange(e) {
    const { t } = this.props;
    let nodeName = e.target.name;
    if (nodeName === "attachmentName") {
      let filename = e.target.files[0].name;
      var upload = filename.split(".").pop();
      if (upload.toLowerCase() === "pdf") {
        $("#AttachmentErrMsg").text("");
        let regex = /^[0-9a-zA-Z\s\(\)\.\_\&\$\#\-\']+$/g;
        if (regex.test(filename)) {
          this.setState({
            ContractUploadstatus: true,
            attachment: e.target.files[0],
            attachmentName: e.target.files[0].name,
          });
        } else {
          // swal(
          //   "Error!",
          //   "Please upload the file without special characters.",
          //   "warning"
          // );
          swal({
            title: t('SwalError.ErrorTitle'),
            text: t('SwalError.UploadFile'),
            icon: 'warning',
            buttons: {
              confirm: {
                text: t('confirmAlertMessage.Ok')
              }
            }
          });
          return;
        }
      } else {
        $("#AttachmentErrMsg").text(`${t("ErrorMessage.Onlyptf")}`);
      }
    }
  }
  handleContractInputChange(e) {
    let nodeName = e.target.name;
    if (nodeName === "contractName") {
      this.state.shipInfo[nodeName] = e.target.value;
      this.setState({});
    } else {
      if (this.state.shipInfo.contractStatus.toLowerCase() === "active") {
        this.setState({ Active: true, Pending: false, Terminated: false });
      }
      if (this.state.shipInfo.contractStatus.toLowerCase() === "terminated") {
        this.setState({ Active: false, Pending: false, Terminated: true });
      } else {
        this.setState({ Active: false, Pending: true, Terminated: false });
      }
    }
  }
  handleCompanyInputChange(e) {
    let nodeName = e.target.name;
    if (nodeName === "fleetmanager") {
      this.state[nodeName] = e.target.value;
      this.state.shipInfo.shipUsers.push({
        userName: e.target.value,
        role: "fleetmanager",
      });
    } else if (nodeName === "superintendent") {
      this.state[nodeName] = e.target.value;
      this.state.shipInfo.shipUsers.push({
        userName: e.target.value,
        role: "superintendent",
      });
    } else if (nodeName === "technicalexecutive") {
      this.state[nodeName] = e.target.value;
      this.state.shipInfo.shipUsers.push({
        userName: e.target.value,
        role: "technicalexecutive",
      });
    } else if (nodeName === "companyName") {
      this.state.fleetmanager = [];
      this.state.superintendent = [];
      this.state.technicalexecutive = [];
      this.props.dispatch(getClientUsersList(e.target.value));
      this.state.shipInfo[nodeName] = e.target.value;
    }
    if (nodeName === "grantAdminId" || nodeName === "approverId") {
      this.state.shipInfo[nodeName] = e.target.value;
    }
    this.setState({});
  }

  handleCompanyInputChange1(nodeName, item) {
    
    if (nodeName === "fleetmanager") {
      this.state[nodeName] = item;
    } else if (nodeName === "superintendent") {
      this.state[nodeName] = item;
    } else if (nodeName === "technicalexecutive") {
      this.state[nodeName] = item;
    }
    else if (nodeName === "grantAdmins") {
      this.state[nodeName] = item;
    }
    else if (nodeName === "")
      this.setState({}, () => {
        let userarray = [];
        this.state.fleetmanager.map((data, index) => {
          let userdata = { "userName": data, "role": 'fleetmanager' };
          userarray.push(userdata);
        })
        this.state.technicalexecutive.map((data, index) => {
          let userdata = { "userName": data, "role": 'technicalexecutive' };
          userarray.push(userdata);
        })
        this.state.superintendent.map((data, index) => {
          let userdata = { "userName": data, "role": 'superintendent' };
          userarray.push(userdata);
        })
        console.log(userarray);
      });
  }
  ClearInput() {
    //this.props.dispatch(deleteAttachmentInBucket(this.state.shipInfo.firePlanGUID,this.state.shipInfo.firePlanName));

    let obj1 = {
      filename: this.state.shipInfo.firePlanName,
      guid: this.state.shipInfo.firePlanGUID,
    }
    fileDatas.push(obj1);
    this.setState({ file: "", fileName: "" });

    let obj = {
      firePlanName: "",
      firePlanGUID: ""
    };
    this.setState({ file: "", fileName: "" });
    this.props.dispatch({
      type: "postFirePlanAttachmentUploadSuccess",
      data: obj,
    });
  }
  ClearAttachmentInput() {
    //this.props.dispatch(deleteAttachmentInBucket(this.state.shipInfo.contractGUID,this.state.shipInfo.nameOfContract));

    let obj1 = {
      filename: this.state.shipInfo.nameOfContract,
      guid: this.state.shipInfo.contractGUID,
    }
    fileDatas.push(obj1);

    let obj = {
      agreementName: "",
      agreementGUID: ""
    };
    // this.setState({ file: "", fileName: "" });
    this.props.dispatch({
      type: "postShipContractAttachmentUploadSuccess",
      data: obj,
    });
    this.setState({ attachment: "", attachmentName: "" });
  }
  render() {
    const {
      showSidePane,
      flagList,
      ClientUsersList,
      ClientNameList,
      ClassList,
      ApproverList,
      CoordinatorList,
      TypeofShipList,
      t,
    } = this.props;
    return (
      <div className="full-height">
        <div className="row pt-3">
          <div className="col-lg-12">
            <div className="panel-box">
              <div className="search-filter-box">
                <div
                  className="card mt-2 MM-card-header mb-0"
                  style={{ backgroundColor: "white" }}
                >
                  <div
                    className="card-body"
                    style={{
                      padding: "0rem",
                      backgroundColor: "#1a3464",
                      color: "white",
                    }}
                  >
                    <h5
                      className="card-title ml-2 mt-2"
                      style={{ color: "092a51" }}
                    >
                      {t("ShipManagementContent.BasicDetails")}
                    </h5>
                  </div>
                </div>
                <div className="row search-filter-box">
                  <div className={showSidePane ? "col-lg-6 mt-1" : "col-lg-4 "}>
                    <label className="form-label fontstyle required">
                      {t("content.Shipname")}
                    </label>
                    <br></br>
                    <input
                      className="form-control"
                      id="shipname"
                      type="text"
                      name="shipName"
                      placeholder={t("content.Shipname")}
                      value={this.state.shipInfo.shipName}
                      onChange={(e) => this.handleInputChange(e)}
                    ></input>
                  </div>
                  <div
                    className={showSidePane ? "col-lg-6 mt-1" : "col-lg-4 mt-0"}
                  >
                    <label className="form-label required">{t("content.IMOno")}</label>
                    <br></br>
                    <input
                      className="form-control"
                      type="text"
                      name="imoNo"
                      id="imono"
                      placeholder={t("content.IMOno")}
                      value={this.state.shipInfo.imoNo}
                      onChange={(e) => this.handleInputChange(e)}
                    ></input>
                  </div>
                  <div
                    className={showSidePane ? "col-lg-6 mt-1" : "col-lg-4 mt-0"}
                  >
                    <label className="form-label required">
                      {t("TopPaneContent.Flag")}
                    </label>
                    <br></br>
                    <select
                      className="form-control"
                      id="flagname"
                      name="flag"
                      value={this.state.shipInfo.flag}
                      onChange={(e) => this.handleInputChange(e)}
                    >
                      <option value="">
                        {t("ShipManagementContent.SelectFlag")}
                      </option>
                      {flagList &&
                        flagList.map((flagname) => (
                          <option value={flagname}>{flagname}</option>
                        ))}
                    </select>
                  </div>
                  <div
                    className={showSidePane ? "col-lg-6 mt-1" : "col-lg-4 mt-1"}
                  >
                    <label className="form-label required">
                      {t("TopPaneContent.Class")}
                    </label>
                    <br></br>
                    <Multiselect
                      id="selectclass"
                      options={this.state.selectClass.length === this.state.maxClassselect ? [] : ClassList}
                      isObject={false}
                      emptyRecordMsg={this.state.selectClass.length === this.state.maxClassselect
                        ? t("CommonText.TwoClassAllowed") : t("CommonText.NotAvailable")}
                      style={{
                        option: {
                          "margin-right": 0,
                          display: "block",
                          "font-weight": "normal",
                        },
                        chips: { "background-color": "#1a3464" },
                      }}
                      onSelect={(item) => this.onSelectChange(item)}
                      onRemove={(item) => this.onRemoveChange(item)}
                      showArrow={true}
                      selectedValues={this.state.selectClass}
                      placeholder={
                        this.state.selectClass && this.state.selectClass.length ? "" : "Select Class"}
                      closeIcon="cancel"
                    />
                  </div>
                  <div
                    className={showSidePane ? "col-lg-6 mt-1" : "col-lg-4 mt-1"}
                  >
                    <label className="form-label">
                      {t("TopPaneContent.TypeofShip")}
                    </label>
                    <br></br>
                    <select
                      className="form-control"
                      name="typeOfShip"
                      value={this.state.shipInfo.typeOfShip}
                      onChange={(e) => this.handleInputChange(e)}
                    >
                      <option value="">
                        {t("ShipManagementContent.SelectTypeofShip")}
                      </option>
                      {TypeofShipList &&
                        TypeofShipList.list.map((typeofship) => (
                          <option value={typeofship}>{typeofship}</option>
                        ))}
                    </select>
                  </div>
                  <div
                    className={showSidePane ? "col-lg-6 mt-1" : "col-lg-4 mt-1"}
                  >
                    <label className="form-label fontstyle required">
                      {t("ShipEquipmentStatusScreen.DateofBuild")}{" "}
                    </label>
                    <br></br>
                    <div
                      className="input-group add-on date datepicker"
                      data-date-format="yyyy-mm-dd"
                    >
                      <input
                        type="text"
                        id="dateofbuild"
                        className="form-control date-picker"
                        placeholder={t("ShipEquipmentStatusScreen.DateofBuild")}
                        value={this.state.shipInfo.dateOfBuild}
                      ></input>
                      <DatePicker
                        showMonthDropdown
                        showYearDropdown
                        onChange={this.handleDateofBuild}
                        open={this.state.DatePickerIsOpen}
                        onClickOutside={this.handleBlur}
                        dropdownMode="select"
                        popperPlacement="top-end"
                        className="form-control date-picker w-5 hide-date"
                      />
                      <div
                        className="input-group-btn calendar-icon"
                        onClick={this.openDatePicker}
                        id="dateofbuild"
                      >
                        <button
                          className="btn btn-default"
                          style={{ height: "100%" }}
                        >
                          <i className="fa fa-calendar mt-1"></i>
                        </button>
                      </div>
                    </div>
                  </div>
                  <div
                    className={showSidePane ? "col-lg-6 mt-1" : "col-lg-4 mt-1"}
                  >
                    <label className="form-label">
                      {t("ShipManagementContent.GRT")}
                    </label>
                    <br></br>
                    <input
                      className="form-control"
                      type="text"
                      name="grt"
                      placeholder={t("ShipManagementContent.GRT")}
                      value={this.state.shipInfo.grt}
                      onChange={(e) => this.handleInputChange(e)}
                    ></input>
                  </div>
                  <div
                    className={showSidePane ? "col-lg-6 mt-1" : "col-lg-4 mt-1"}
                  >
                    <label className="form-label">
                      {t("ShipManagementContent.DeadWeight")}
                    </label>
                    <br></br>
                    <input
                      className="form-control"
                      type="text"
                      name="deadWeight"
                      placeholder={t("ShipManagementContent.DeadWeight")}
                      value={this.state.shipInfo.deadWeight}
                      onChange={(e) => this.handleInputChange(e)}
                    ></input>
                  </div>
                  <div
                    className={showSidePane ? "col-lg-6 mt-1" : "col-lg-4 mt-1"}
                  >
                    <label className="form-label fontstyle required">
                      {t("EquipmentSeviceDetailsScreen.EnrollmentDate")}{" "}
                    </label>
                    <br></br>
                    <div
                      className="input-group add-on date datepicker"
                      data-date-format="yyyy-mm-dd"
                    >
                      <input
                        type="text"
                        id="enrollmentdate"
                        className="form-control date-picker"
                        placeholder={t(
                          "EquipmentSeviceDetailsScreen.EnrollmentDate"
                        )}
                        value={this.state.shipInfo.enrollmentDate}
                      ></input>
                      <DatePicker
                        showMonthDropdown
                        showYearDropdown
                        onChange={this.handleEnrollmentDate}
                        open={this.state.EnrollmentDatePickerIsOpen}
                        onClickOutside={this.handleBlur}
                        dropdownMode="select"
                        popperPlacement="top-end"
                        className="form-control date-picker w-5 hide-date"
                      />
                      <div
                        className="input-group-btn calendar-icon"
                        onClick={this.openEnrollmentDatePicker}
                        id="enrollmentdate"
                      >
                        <button
                          className="btn btn-default"
                          style={{ height: "100%" }}
                        >
                          <i className="fa fa-calendar mt-1"></i>
                        </button>
                      </div>
                    </div>
                  </div>
                  <div
                    className={showSidePane ? "col-lg-6 mt-1" : "col-lg-4 mt-1"}
                  >
                    <label className="form-label">
                      {t("ShipEquipmentStatusScreen.FirePlan")}
                    </label>
                    <br></br>
                    <div class="input-group ">
                      <div class="input-group-prepend">
                        <span class="input-group-text">
                          {t("CommonText.BrowseFile")}
                          <input
                            type="file"
                            id="files"
                            name="fileName"
                            style={{ marginRight: 40 }}
                            onChange={(e) => this.handleInputChange(e)}
                            onClick={(event) => {
                              event.currentTarget.value = null;
                            }}
                          />
                        </span>
                      </div>
                      <input
                        type="text"
                        class="form-control"
                        placeholder={t("CommonText.Nofilechoosen")}
                        value={this.state.fileName}
                      />
                      {this.state.fileName ? (
                        <div
                          class="input-group-append"
                          style={{ cursor: "pointer" }}
                        >
                          <i
                            class="fa fa-times input-group-text "
                            aria-hidden="true"
                            onClick={() => this.ClearInput()}
                          ></i>
                        </div>
                      ) : (
                        ""
                      )}
                    </div>
                    <span id="FileErrMsg" className="spanErrMsg"></span>
                  </div>
                  <div
                    className={showSidePane ? "col-lg-6 mt-1" : "col-lg-4 mt-1"}
                  >
                    <label className="form-label">
                      {t("ShipEquipmentStatusScreen.ContractAttachment")}
                    </label>
                    <br></br>
                    <div class="input-group ">
                      <div class="input-group-prepend">
                        <span class="input-group-text">
                          {t("CommonText.BrowseFile")}
                          <input
                            type="file"
                            id="files"
                            name="attachmentName"
                            style={{ marginRight: 40 }}
                            onChange={(e) =>
                              this.handleAttachmentInputChange(e)
                            }
                            onClick={(event) => {
                              event.currentTarget.value = null;
                            }}
                          />
                        </span>
                      </div>
                      <input
                        type="text"
                        class="form-control"
                        placeholder={t("CommonText.Nofilechoosen")}
                        value={this.state.attachmentName}
                      />
                      {this.state.attachmentName ? (
                        <div
                          class="input-group-append"
                          style={{ cursor: "pointer" }}
                        >
                          <i
                            class="fa fa-times input-group-text"
                            aria-hidden="true"
                            onClick={() => this.ClearAttachmentInput()}
                          ></i>
                        </div>
                      ) : (
                        ""
                      )}
                    </div>
                    <span id="AttachmentErrMsg" className="spanErrMsg"></span>
                  </div>
                  <div
                    className={showSidePane ? "col-lg-6 mt-1" : "col-lg-4 mt-1"}
                  >
                    <label className="form-label">
                      {t("ShipEquipmentStatusScreen.IsInContract")}
                    </label>
                    <br></br>
                    <input type="checkbox" className="checkbox-style" checked={this.state.shipInfo.isContract} onChange={(event) => this.setState({
                      shipInfo: {
                        ...this.state.shipInfo,
                        isContract: event.target.checked
                      }
                    })} />
                    {/* <span id="AttachmentErrMsg" className="spanErrMsg"></span> */}
                  </div>
                </div>
              </div>
              {/* <div className="search-filter-box">
                <div
                  className="card mt-2 MM-card-header mb-0"
                  style={{ backgroundColor: "white" }}
                >
                  <div
                    className="card-body"
                    style={{
                      padding: "0rem",
                      backgroundColor: "#1a3464",
                      color: "white",
                    }}
                  >
                    <h5
                      className="card-title ml-2 mt-2"
                      style={{ color: "092a51" }}
                    >
                      Contract Details
                    </h5>
                  </div>
                </div>
                <div className="row search-filter-box">
                  <div className={showSidePane ? "col-lg-6 mt-1" : "col-lg-4 mt-1"}>
                    <label className="form-label required">
                      {t("ShipEquipmentStatusScreen.ContractType")}
                    </label>
                    <br></br>
                    <select
                      className="form-control"
                      name="contractType"
                      id="contractType"
                      value={this.state.shipInfo.contractType}
                      onChange={(e) => this.handleInputChange(e)}
                    >
                      <option value="">
                        {t("ShipManagementContent.SelectContractType")}
                      </option>
                      <option value="1">FZM</option>
                      <option value="2">IFS</option>
                    </select>
                  </div>
                  <div className={showSidePane ? "col-lg-6 mt-1" : "col-lg-4 mt-1"}>
                    <label className="form-label required">
                      {t("ShipEquipmentStatusScreen.PlanType")}
                    </label>
                    <br></br>
                    <select
                      className="form-control"
                      name="planType"
                      id="planType"
                      value={this.state.shipInfo.planType}
                      onChange={(e) => this.handleInputChange(e)}
                    >
                      <option value="">
                        {t("ShipManagementContent.SelectPlanType")}
                      </option>
                      <option value="1">BASIC</option>
                      <option value="2">STD</option>
                      <option value="3">PREMIUM</option>
                    </select>
                  </div>
                </div>
              </div> */}
              <div className="search-filter-box">
                <div
                  className="card MM-card-header mb-0"
                  style={{ backgroundColor: "white" }}
                >
                  <div
                    className="card-body"
                    style={{
                      padding: "0rem",
                      backgroundColor: "#1a3464",
                      color: "white",
                    }}
                  >
                    <h5
                      className="card-title ml-2 mt-2"
                      style={{ color: "092a51" }}
                    >
                      {t("ShipManagementContent.ShipContactDetails")}
                    </h5>
                  </div>
                </div>
                <div className="row search-filter-box">
                  <div className={showSidePane ? "col-lg-6" : "col-lg-4"}>
                    <label className="form-label fontstyle required">
                      {t("DashboardMoreInformation.ShipEmail")}
                    </label>
                    <br></br>
                    <input
                      className="form-control"
                      type="email"
                      id="shipemail"
                      name="shipEmail"
                      placeholder={t("DashboardMoreInformation.ShipEmail")}
                      value={this.state.shipInfo.shipEmail}
                      onChange={(e) => this.handleInputChange(e)}
                    ></input>
                  </div>
                  <div className={showSidePane ? "col-lg-6" : "col-lg-4"}>
                    <label className="form-label">
                      {t("DashboardMoreInformation.ShipContactNumber1")}
                    </label>
                    <br></br>
                    <input
                      className="form-control"
                      type="text"
                      pattern="[0-9]*"
                      name="phone1"
                      placeholder={t(
                        "DashboardMoreInformation.ShipContactNumber1"
                      )}
                      value={this.state.shipInfo.phone1}
                      onChange={(e) => this.handleInputChange(e)}
                    ></input>
                  </div>
                  <div className={showSidePane ? "col-lg-6" : "col-lg-4"}>
                    <label className="form-label">
                      {t("DashboardMoreInformation.ShipContactNumber2")}
                    </label>
                    <br></br>
                    <input
                      className="form-control"
                      type="text"
                      pattern="[0-9]*"
                      name="phone2"
                      placeholder={t(
                        "DashboardMoreInformation.ShipContactNumber2"
                      )}
                      value={this.state.shipInfo.phone2}
                      onChange={(e) => this.handleInputChange(e)}
                    ></input>
                  </div>
                  <div className={showSidePane ? "col-lg-6" : "col-lg-4"}>
                    <label className="form-label">
                      {t("DashboardMoreInformation.InvoiceForwardingEmail")}
                    </label>
                    <br></br>
                    <input
                      className="form-control"
                      type="email"
                      name="invoiceForwardingEmail"
                      placeholder={t(
                        "DashboardMoreInformation.InvoiceForwardingEmail"
                      )}
                      value={this.state.shipInfo.invoiceForwardingEmail}
                      onChange={(e) => this.handleInputChange(e)}
                    ></input>
                  </div>
                  <div className={showSidePane ? "col-lg-6" : "col-lg-4"}>
                    <label className="form-label">
                      {t("DashboardMoreInformation.VesselGroupEmail")}
                    </label>
                    <br></br>
                    <input
                      className="form-control"
                      type="email"
                      name="vesselGroupEmail"
                      placeholder={t(
                        "DashboardMoreInformation.VesselGroupEmail"
                      )}
                      value={this.state.shipInfo.vesselGroupEmail}
                      onChange={(e) => this.handleInputChange(e)}
                    ></input>
                  </div>
                </div>
              </div>
              <div className="search-filter-box">
                <div
                  className="card MM-card-header mb-0"
                  style={{ backgroundColor: "white" }}
                >
                  <div
                    className="card-body"
                    style={{
                      padding: "0rem",
                      backgroundColor: "#1a3464",
                      color: "white",
                    }}
                  >
                    <h5
                      className="card-title ml-2 mt-2"
                      style={{ color: "092a51" }}
                    >
                      {t("DashboardMoreInformation.CompanyDetails")}
                    </h5>
                  </div>
                </div>
                <div className="row search-filter-box">
                  <div className={showSidePane ? "col-lg-6 " : "col-lg-4"}>
                    <label className="form-label fontstyle required">
                      {t("ShipManagementContent.CompanyName")}
                    </label>
                    <br></br>
                    <select
                      className="form-control"
                      id="companyname"
                      name="companyName"
                      value={this.state.shipInfo.companyName}
                      onChange={(e) => this.handleCompanyInputChange(e)}
                    >
                      <option value="">
                        {t("ShipManagementContent.SelectCompanyName")}
                      </option>
                      {ClientNameList &&
                        ClientNameList.clients.map((clientname) => (
                          <option value={clientname}>{clientname}</option>
                        ))}
                    </select>
                  </div>
                  <div className={showSidePane ? "col-lg-6 " : "col-lg-8"}></div>
                  <div className={showSidePane ? "col-lg-6" : "col-lg-4"}>
                    <label className="form-label">
                      {t("ShipManagementContent.FleetManager")}
                    </label>
                    {/* <br></br> */}
                    <Multiselect
                      options={ClientUsersList?.fleetManagers ?? []}
                      id="ServiceType"
                      showArrow={true}
                      isObject={false}
                      style={{
                        option: {
                          marginRight: 0,
                          display: "block",
                          fontWeight: "normal",
                        },
                        chips: { "background-color": "#1a3464" },
                      }}
                      onSelect={(item) => this.handleCompanyInputChange1("fleetmanager", item)}
                      onRemove={(item) => this.handleCompanyInputChange1("fleetmanager", item)}
                      selectedValues={this.state.fleetmanager}
                      placeholder={
                        this.state.fleetmanager && this.state.fleetmanager.length ? "" : "Select fleet manager"}
                      closeIcon="cancel"
                    />
                    {/* <select
                      className="form-control"
                      name="fleetmanager"
                      value={this.state.fleetmanager}
                      onChange={(e) => this.handleCompanyInputChange(e)}
                    >
                      <option value="">
                        {t("ShipManagementContent.SelectFleetManager")}
                      </option>
                      {ClientUsersList && ClientUsersList.fleetManagers ? (
                        ClientUsersList.fleetManagers.map(
                          (fleetmanagername) => (
                            <option value={fleetmanagername}>
                              {fleetmanagername}
                            </option>
                          )
                        )
                      ) : (
                        <option value=""></option>
                      )}
                    </select> */}
                  </div>
                  <div className={showSidePane ? "col-lg-6" : "col-lg-4"}>
                    <label className="form-label">
                      {t("ShipManagementContent.TechnicalSuperintendent")}
                    </label>
                    {/* <br></br> */}
                    <Multiselect
                      options={ClientUsersList?.superintendents ?? []}
                      id="ServiceType"
                      showArrow={true}
                      isObject={false}
                      style={{
                        option: {
                          marginRight: 0,
                          display: "block",
                          fontWeight: "normal",
                        },
                        chips: { "background-color": "#1a3464" },
                      }}
                      onSelect={(item) => this.handleCompanyInputChange1("superintendent", item)}
                      onRemove={(item) => this.handleCompanyInputChange1("superintendent", item)}
                      selectedValues={this.state.superintendent}
                      placeholder={
                        this.state.superintendent && this.state.superintendent.length ? "" : "Select superintendent"}
                      closeIcon="cancel"
                    />
                    {/* <select
                      className="form-control"
                      name="superintendent"
                      value={this.state.superintendent}
                      onChange={(e) => this.handleCompanyInputChange(e)}
                    >
                      <option value="">
                        {t(
                          "ShipManagementContent.SelectTechnicalSuperintendent"
                        )}
                      </option>
                      {ClientUsersList && ClientUsersList.superintendents ? (
                        ClientUsersList.superintendents.map(
                          (superintendentname) => (
                            <option value={superintendentname}>
                              {superintendentname}
                            </option>
                          )
                        )
                      ) : (
                        <option value=""></option>
                      )}
                    </select> */}
                  </div>
                  <div className={showSidePane ? "col-lg-6" : "col-lg-4"}>
                    <label className="form-label">
                      {t("ShipManagementContent.TechnicalExecutive")}
                    </label>
                    {/* <br></br> */}
                    <Multiselect
                      options={ClientUsersList?.technicalExecutives ?? []}
                      id="ServiceType"
                      showArrow={true}
                      isObject={false}
                      style={{
                        option: {
                          marginRight: 0,
                          display: "block",
                          fontWeight: "normal",
                        },
                        chips: { "background-color": "#1a3464" },
                      }}
                      onSelect={(item) => this.handleCompanyInputChange1("technicalexecutive", item)}
                      onRemove={(item) => this.handleCompanyInputChange1("technicalexecutive", item)}
                      selectedValues={this.state.technicalexecutive}
                      placeholder={
                        this.state.technicalexecutive && this.state.technicalexecutive.length ? "" : "Select technical executive"}
                      closeIcon="cancel"
                    />
                    {/* <select
                      className="form-control"
                      name="technicalexecutive"
                      value={this.state.technicalexecutive}
                      onChange={(e) => this.handleCompanyInputChange(e)}
                    >
                      <option value="">
                        {t("ShipManagementContent.SelectTechnicalExecutive")}
                      </option>
                      {ClientUsersList &&
                        ClientUsersList.technicalExecutives ? (
                        ClientUsersList.technicalExecutives.map(
                          (executivename) => (
                            <option value={executivename}>
                              {executivename}
                            </option>
                          )
                        )
                      ) : (
                        <option value=""></option>
                      )}
                    </select> */}
                  </div>
                </div>
              </div>
              {/* <div className="search-filter-box">
                                <div className="card MM-card-header mb-0" style={{ backgroundColor: "white" }}>
                                    <div className="card-body" style={{ padding: "0rem", backgroundColor: "#1a3464", color: "white" }}><h5 className="card-title ml-2 mt-2" style={{ color: "092a51" }}>Contract</h5></div>
                                </div>
                                <div className="row search-filter-box">
                                    <div className={showSidePane ? "col-lg-6" : "col-lg-4"}>
                                        <label className="form-label">Contract Name</label><br></br>
                                        <input className="form-control" name="contractName" value={this.state.shipInfo.contractName} placeholder="Contract Name" onChange={e => this.handleContractInputChange(e)}></input>
                                    </div>
                                    <div className={showSidePane ? "col-lg-6" : "col-lg-8"}>
                                        <label className="form-label">Contract Status</label><br></br>
                                        <div className="row col-sm-12">
                                            <div className="radio">
                                                <input type="radio" value="Pending" name="ContractStatus" onChange={e => this.handleContractInputChange(e)}></input>
                                                <span className="ml-1 mr-3">Pending</span>
                                            </div>
                                            <div className="radio">
                                                <input type="radio" value="Active" name="ContractStatus" onChange={e => this.handleContractInputChange(e)}></input>
                                                <span className="ml-1 mr-3">Active</span>
                                            </div>
                                            <div className="radio">
                                                <input type="radio" value="Terminated" name="ContractStatus" onChange={e => this.handleContractInputChange(e)}></input>
                                                <span className="ml-1 mr-3">Terminated</span>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div> */}
              <div className="search-filter-box">
                <div
                  className="card MM-card-header"
                  style={{ backgroundColor: "white" }}
                >
                  <div
                    className="card-body flex"
                    style={{
                      padding: "0rem",
                      backgroundColor: "#1a3464",
                      color: "white",
                    }}
                  >
                    <h5
                      className="card-title ml-2 mt-2"
                      style={{ color: "092a51" }}
                    >
                      {t("ShipManagementContent.AssignUsers")}
                    </h5>
                    {/*  <div
                      className="m-1 flex"
                      onClick={() => this.showEquipmentSidePane()}
                    >
                      <span class="mt-1">Add </span>
                      <AddIcon />
                    </div> */}
                  </div>
                </div>
                <div className=" row search-filter-box">
                  <div className={showSidePane ? "col-lg-6" : "col-lg-4"}>
                    <label className="form-label">
                      {t("ShipManagementContent.Coordinator")}
                    </label>
                    <br></br>
                    <Multiselect
                      options={CoordinatorList ?? []}
                      id="ServiceType"
                      showArrow={true}
                      isObject={true}
                      displayValue="name"
                      avoidHighlightFirstOption={true}
                      style={{
                        option: {
                          marginRight: 0,
                          display: "block",
                          fontWeight: "normal",
                        },
                        chips: { "background-color": "#1a3464" },
                      }}
                      onSelect={(item) => this.handleCompanyInputChange1("grantAdmins", item)}
                      onRemove={(item) => this.handleCompanyInputChange1("grantAdmins", item)}
                      selectedValues={this.state.grantAdmins}
                      placeholder={
                        this.state.grantAdmins && this.state.grantAdmins.length ? "" : "Select Co-ordinator"}
                      closeIcon="cancel"
                    />
                    {/* <select
                      className="form-control"
                      id="grandadmin"
                      name="grantAdminId"
                      value={this.state.shipInfo.grantAdminId}
                      onChange={(e) => this.handleCompanyInputChange(e)}
                    >
                      <option value="">
                        {t("ShipManagementContent.SelectCoordinator")}
                      </option>
                      {CoordinatorList ? (
                        CoordinatorList?.map((coordinatorname) => (
                          <option value={coordinatorname.id}>
                            {coordinatorname.name}
                          </option>
                        ))
                      ) : (
                        <option value=""></option>
                      )}
                    </select> */}
                  </div>
                  <div className={showSidePane ? "col-lg-6" : "col-lg-4"}>
                    <label className="form-label">
                      {t("ShipManagementContent.Approver")}
                    </label>
                    <br></br>
                    <select
                      className="form-control"
                      style={{ height: '41px' }}
                      name="approverId"
                      id="approver"
                      value={this.state.shipInfo.approverId}
                      onChange={(e) => this.handleCompanyInputChange(e)}
                    >
                      <option value="">
                        {t("ShipManagementContent.SelectApprover")}
                      </option>
                      {ApproverList ? (
                        ApproverList?.map((approvername) => (
                          <option value={approvername.id}>
                            {approvername.name}
                          </option>
                        ))
                      ) : (
                        <option value=""></option>
                      )}
                    </select>
                  </div>
                  {/*    {this.renderEquipmentCard()} */}
                </div>
              </div>
              <div className="search-filter-box">
                <div
                  className="card MM-card-header"
                  style={{ backgroundColor: "white" }}
                >
                  <div
                    className="card-body flex"
                    style={{
                      padding: "0rem",
                      backgroundColor: "#1a3464",
                      color: "white",
                    }}
                  >
                    <h5
                      className="card-title ml-2 mt-2"
                      style={{ color: "092a51" }}
                    >
                      {t("ComplianceandBudgetScreen.Equipments")}
                    </h5>
                    <div
                      className="m-1 flex"
                      onClick={() => this.showEquipmentSidePane()}
                    >
                      <span class="mt-1">
                        {t("ShipManagementContent.Add")}{" "}
                      </span>
                      <AddIcon />
                    </div>
                  </div>
                </div>
                <div className="search-filter-box">
                  {this.renderEquipmentCard()}
                </div>
              </div>
              <div className="pb-4 pl-4 pr-4">
                <div className="search-btn-col" style={{ textAlign: "end" }}>
                  {/* <button
                    className="btn btn-primary text-uppercase txtside-btn txtht-btn blue"
                    type="submit"
                    onClick={() => this.AssignUsers()}
                  >
                    {" "}
                    {t("ShipManagementContent.AssigntoCoordinator")}{" "}
                  </button> */}
                  <button
                    className="btn btn-primary text-uppercase txtside-btn txtht-btn blue "
                    type="submit"
                    onClick={() => this.AddShipDraft()}
                  >
                    {" "}
                    {t("ShipManagementContent.SaveasDraft")}{" "}
                  </button>
                  <button
                    className="btn btn-primary text-uppercase txtside-btn txtht-btn blue ml-3"
                    type="submit"
                    onClick={() => this.AddShipActive()}
                  >
                    {" "}
                    {t("ShipManagementContent.SubmitActive")}{" "}
                  </button>
                  <button
                    className="btn btn-light text-uppercase txtside-btn txtht-btn ml-3"
                    type="button"
                    onClick={() => this.CancelAddship()}
                  >
                    {" "}
                    {t("ComplianceandBudgetScreen.Cancel")}{" "}
                  </button>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    );
  }

  renderEquipmentCard = () => {
    const { EquipmentArray, t } = this.props;
    return EquipmentArray && EquipmentArray.length ? (
      EquipmentArray.map((item, index) => {
        return (
          <div
            className="card MM-card-content mb-2 click"
            style={{
              backgroundColor: "#f0f0f0",
              overflow: "hidden",
              position: "relative",
            }}
          >
            <div className="p-3">
              <div className="resource-list-auth-date">
                <div className="row">
                  <div className={"col-sm-10 col-md-10 m-auto"}>
                    <div className="row">
                      <div className="col-sm-12 col-md-12">
                        <h6 className="resource-list-title">
                          {item.equipmentName}
                        </h6>
                      </div>
                      {/* <div className={showSidePane ? "col-sm-6 mb-1" : "col-sm-4 mb-2"}>
                                                <span><strong>Category: </strong>{item.category} </span>
                                            </div>
                                            <div className={showSidePane ? "col-sm-6 mb-1" : "col-sm-4 mb-2"}>
                                                <span><strong>Type: </strong>{item.equipmentType}</span>
                                            </div> */}
                      <div className={"col-md-4 col-sm-6 mt-2"}>
                        <span>
                          <strong>{t("TopPaneContent.Category")}: </strong>
                          {item.category}{" "}
                        </span>
                      </div>
                      <div className={"col-md-4 col-sm-6 mt-2"}>
                        <span>
                          <strong>
                            {t("ComplianceandBudgetScreen.Type")}:{" "}
                          </strong>
                          {item.equipmentType}
                        </span>
                      </div>
                      <div className={"col-md-4 col-sm-6 mt-2"}>
                        <span>
                          <strong>
                            {t("ShipEquipmentStatusScreen.ManufacturingDate")}:{" "}
                          </strong>
                          {item.dateOfBuild}
                        </span>
                      </div>
                      {item?.equipmentName
                        .toLowerCase()
                        .includes("lifeboat") ? (
                        <>
                          <div className={"col-md-4 col-sm-6 mt-2"}>
                            <span>
                              <strong>
                                {t("EditEquipmentScreenContent.LifeboatMake")} :{" "}
                              </strong>
                              {item.lifeboatMake}{" "}
                            </span>
                          </div>
                          <div className={"col-md-4 col-sm-6 mt-2"}>
                            <span>
                              <strong>
                                {" "}
                                {t(
                                  "EditEquipmentScreenContent.Davit/winchMake"
                                )}{" "}
                                :{" "}
                              </strong>
                              {item.davitwinchMake}{" "}
                            </span>
                          </div>
                          <div className={"col-md-4 col-sm-6 mt-2"}>
                            <span>
                              <strong>
                                {" "}
                                {t(
                                  "EditEquipmentScreenContent.LifeboatModel"
                                )}{" "}
                                :{" "}
                              </strong>
                              {item.lifeboatModel}{" "}
                            </span>
                          </div>
                          <div className={"col-md-4 col-sm-6 mt-2"}>
                            <span>
                              <strong>
                                {" "}
                                {t(
                                  "EditEquipmentScreenContent.LifeboatRelease"
                                )}{" "}
                                :{" "}
                              </strong>
                              {item.lifeboatRelease}{" "}
                            </span>
                          </div>
                        </>
                      ) : item?.equipmentName
                        .toLowerCase()
                        .includes("rescue boat") ? (
                        <>
                          <div className={"col-md-4 col-sm-6 mt-2"}>
                            <span>
                              <strong>
                                {t("EditEquipmentScreenContent.rescueboatMake")}{" "}
                                :{" "}
                              </strong>
                              {item.rescueboatMake}{" "}
                            </span>
                          </div>
                          <div className={"col-md-4 col-sm-6 mt-2"}>
                            <span>
                              <strong>
                                {t(
                                  "EditEquipmentScreenContent.rescueboatDavit/winchMake"
                                )}{" "}
                                :{" "}
                              </strong>
                              {item.rescueboatdavitwinchMake}{" "}
                            </span>
                          </div>
                          <div className={"col-md-4 col-sm-6 mt-2"}>
                            <span>
                              <strong>
                                {t(
                                  "EditEquipmentScreenContent.rescueboatModel"
                                )}{" "}
                                :{" "}
                              </strong>
                              {item.rescueboatModel}{" "}
                            </span>
                          </div>
                          <div className={"col-md-4 col-sm-6 mt-2"}>
                            <span>
                              <strong>
                                {" "}
                                {t(
                                  "EditEquipmentScreenContent.rescueboatRelease"
                                )}{" "}
                                :{" "}
                              </strong>
                              {item.rescueboatRelease}{" "}
                            </span>
                          </div>
                        </>
                      ) : (
                        <>
                          <div className={"col-md-4 col-sm-6 mt-2"}>
                            <span>
                              <strong>
                                {t("ShipEquipmentStatusScreen.Make")} :{" "}
                              </strong>
                              {item.make}{" "}
                            </span>
                          </div>
                          <div className={"col-md-4 col-sm-6 mt-2"}>
                            <span>
                              <strong>
                                {t("ShipEquipmentStatusScreen.Model")} :{" "}
                              </strong>
                              {item.model}{" "}
                            </span>
                          </div>
                        </>
                      )}

                      <div className={"col-md-4 col-sm-6 mt-2"}>
                        <span>
                          <strong>
                            {t("ShipEquipmentStatusScreen.Quantity")}:{" "}
                          </strong>
                          {item.quantity > 0 ? item.quantity : ""}
                        </span>
                      </div>
                      <div className={"col-md-4 col-sm-6 mt-2"}>
                        <span>
                          <strong>
                            {t("ShipEquipmentStatusScreen.Unit-Quantity")}:{" "}
                          </strong>
                          {item.unit}
                        </span>
                      </div>
                      <div className={"col-md-4 col-sm-6 mt-2"}>
                        <span>
                          <strong>
                            {t("ShipEquipmentStatusScreen.Capacity")} /{" "}
                            {t("ShipEquipmentStatusScreen.Size")}:{" "}
                          </strong>
                          {item.capacity}
                        </span>
                      </div>
                    </div>
                  </div>
                  <div className="col-sm-2 col-md-2 m-auto text-right">
                    <i
                      className="fa fa-edit fa-2x"
                      onClick={() => this.EditEquipment(item)}
                    ></i>
                  </div>
                </div>
              </div>
            </div>
          </div>
        );
      })
    ) : (
      <div class="container">
        <h6 className="resource-list-title no-item-card">
          {t("CommonText.NoEquipmentMsg")}{" "}
        </h6>
      </div>
    );
  };

  EditEquipment(item) {
    const { t } = this.props
    if (this.state.shipInfo.flag !== "" && this.state.selectClass.length !== 0) {
      var flagdata = {
        "flag": this.state.shipInfo.flag,
        "class": this.state.selectClass
      }
      this.props.dispatch({ type: "flagandclass", data: flagdata })
      console.log(this.props.applicableServiceTypeInterval, 'item')
      this.props.dispatch({ type: "editEquipment", data: true });
      this.props.dispatch({ type: "ShowSidePan", data: true });
      this.props.dispatch({ type: "getEquipmentDetails", data: item });
      this.props.history.push("/Home/ShipManagementNewItem/NewEquipment");
      window.scrollTo(0, 0);
    }
    else {
      toast.success(t('Toast.Fill'), {
        position: "top-right",
        autoClose: 2500,
        hideProgressBar: true,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: true,
        progress: undefined,
      });
    }
  }

  showEquipmentSidePane() {
    const { t } = this.props
    if (this.state.shipInfo.flag !== "" && this.state.selectClass.length !== 0) {
      var flagdata = {
        "flag": this.state.shipInfo.flag,
        "class": this.state.selectClass
      }
      this.props.dispatch({ type: "flagandclass", data: flagdata })
      this.props.dispatch({ type: "ShowSidePan", data: true });
      this.props.dispatch({ type: "editEquipment", data: false });
      this.props.dispatch({
        type: "getEquipmentDropDownListSuccess",
        data: null,
      });
      this.props.dispatch({ type: "getMakesListEquipmentSuccess", data: [] });
      this.props.dispatch({ type: "getModelsListEquipmentSuccess", data: [] });
      this.props.dispatch({ type: "getServiceTypeListSuccess", data: null });
      this.props.dispatch({
        type: "getServiceTypeIntervalListSuccess",
        data: null,
      });
      this.props.dispatch({
        type: "getServiceTypeIntervalListFlagSuccess",
        data: null,
      });
      this.props.history.push("/Home/ShipManagementNewItem/NewEquipment");
      this.props.dispatch({ type: "annualAttachmentUploadSuccess", data: "" });
      this.props.dispatch({ type: "getShipServiceProviderIDSuccess", data: [] });
      window.scrollTo(0, 0);
    }
    else {
      toast.success(t('Toast.Fill'), {
        position: "top-right",
        autoClose: 2500,
        hideProgressBar: true,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: true,
        progress: undefined,
      });
    }
  }
}

function mapDispatchToProps(dispatch) {
  return {
    dispatch,
  };
}
function mapStateToProps(state) {
  return {
    FirePlanAttachment: state.lookupReducer.FirePlanAttachment,
    ShipContractAttachment: state.lookupReducer.ShipContractAttachment,
    flagList: state.MasterScreenReducer.flagList,
    ClientUsersList: state.MasterScreenReducer.ClientUsersList,
    ClientNameList: state.MasterScreenReducer.ClientNameList,
    showSidePane: state.SidePanReducer.sidePan,
    EquipmentArray: state.MasterScreenReducer.EquipmentArray,
    ClassList: state.MasterScreenReducer.ClassList,
    TypeofShipList: state.MasterScreenReducer.TypeofShipList,
    ApproverList: state.ShipEquipmentReducer.ApproverList,
    CoordinatorList: state.ShipEquipmentReducer.CoordinatorList,
    applicableServiceType: state.MasterScreenReducer.applicableServiceTypeInterval
  };
}
export default withTranslation()(
  withRouter(
    connect(mapStateToProps, mapDispatchToProps)(ShipManagementNewItem)
  )
);
